var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 12.575 12.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-save",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13442",
    "data-name": "Path 13442",
    d: "M14.227,4H13.091V7.409a.568.568,0,0,1-.568.568H7.409a.568.568,0,0,1-.568-.568V4h-1.7A1.136,1.136,0,0,0,4,5.136V15.364A1.136,1.136,0,0,0,5.136,16.5H15.364A1.136,1.136,0,0,0,16.5,15.364V6.273Zm0,11.364H6.273V11.955a1.136,1.136,0,0,1,1.136-1.136h5.682a1.136,1.136,0,0,1,1.136,1.136Z",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13443",
    "data-name": "Path 13443",
    d: "M16,4h1.136V6.841H16Z",
    transform: "translate(-5.182)",
    fill: "#533ffb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.a75e058d99ac1cda7ce1b096dbd827b6.svg";
export { ForwardRef as ReactComponent };